// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal_attached-layout {\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: 15px;\n  position: relative; }\n  .modal_attached-layout .close-icon {\n    font-size: 1.4rem;\n    color: var(--secondary);\n    position: absolute;\n    top: 10px;\n    right: 10px; }\n    .modal_attached-layout .close-icon:hover {\n      cursor: pointer; }\n", ""]);
// Exports
module.exports = exports;
